/**
 * 面包屑搜索框按钮
 * 
 * @Author: Focci
 * @Date: 2024-01-18 09:58:43
 * @Last Modified by: Focci
 * @Last Modified time: 2024-01-18 09:58:43
 */

import PropTypes from 'prop-types'
import SearchIcon from '@mui/icons-material/Search'
import { useTranslations } from 'next-intl'
import clsx from 'clsx'

export default function BreadcrumbSearchTrigger({ 
  onOpen = () => {},
  loading = false
}) {
  const th = useTranslations('house')
  const props = !loading 
    ? { onKeyPress: onOpen, onClick: onOpen, role: 'button', tabIndex: '0' }
    : null

  return (
    <div
      {...props}
      className={clsx([
        'border border-ce6 rounded-sm h-8 pl-2 pr-2 md:pr-12 flex items-center gap-1',
        !loading ? 'select-none cursor-pointer hover:bg-cf8' : 'opacity-80'
      ])}
    >
      <div className="flex items-center text-cd1 pointer-events-none">
        <SearchIcon sx={{ fontSize: '1.2rem' }} />
      </div>
      <span className="text-helper whitespace-nowrap">
        {th('typeAndSearch')}
      </span>
    </div>
  )
}

BreadcrumbSearchTrigger.propTypes = {
  onOpen: PropTypes.func,
}
